export default __webpack_public_path__ + "static/media/bookPurple.59d5e99b.svg";